module.exports = __webpack_public_path__ + "static/media/sweet.74acafb6.png";